import { Route, Routes, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useEffect } from "react";
import Url from "../../../apiCall/UrlConfig";
import { Button, Table, message } from "antd";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const ListAnalysesOpgNumbering = (props) => {
  let navigate = useNavigate();
  const ColumnsAnalyses = [
    {
      title: "Patient Id",
      dataIndex: "PatientID",
      key: "PatientId",
      render: (object, item) => {
        return <div>{item.patientId}</div>;
      },
    },
    {
      title: "Patient Image Id",
      dataIndex: "PatientID",
      key: "PatientId",
      render: (object, item) => {
        return <div>{item.patientImageId}</div>;
      },
    },
    {
      title: "Analyses",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        return <Button onClick={() => _onClickEditAnalyses(item)}>Edit</Button>;
      },
    },
  ];

  useEffect(() => {
    _getListAnalyses();
  }, []);
  const _getListAnalyses = async () => {
    let url = Url.opgnumberinglistAnalyses;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  const _onClickEditAnalyses = (item) => {
    console.log(item);
    navigate(
      "/opgnumbering/mainpage/analyses/" + item.patientImageId + "/" + item.id
    );
  };
  return (
    <div>
      <Table
        columns={ColumnsAnalyses}
        dataSource={
          props.coreData[Url.opgnumberinglistAnalyses]?.[Url.action]?.data
        }
      />
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListAnalysesOpgNumbering);
